/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { IconButton, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/grading';

const styles = {
  nav: () => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,
};

type PaginationXsProps = {
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (pageNumber: number) => void;
};

/**
 * A simplified version of CDS Pagination component.
 * It renders XS variant on any screen size to fit any container width.
 * The reason for this local implementation was originated due to limitation
 * in CDS component to render XS variant on large screens.
 *
 * This is an edge case specific to the Quick Grader, and should not be used
 * beyond this page.
 *
 * Context: https://coursera.atlassian.net/browse/GRADE-4374
 */
const PaginationXs = (props: PaginationXsProps) => {
  const { page, pageSize, total, onPageChange } = props;

  const totalPages = Math.ceil(total / pageSize);

  return (
    <nav aria-label="pagination" css={styles.nav}>
      <IconButton
        variant="secondary"
        size="small"
        aria-label={_t('Go to previous page')}
        disabled={page === 1}
        onClick={() => onPageChange(page - 1)}
        intent="previous"
      />
      <Typography2 component="p" role="status">
        {_t(`Page #{page} of #{totalPages}`, { page, totalPages })}
      </Typography2>
      <IconButton
        variant="secondary"
        size="small"
        aria-label={_t('Go to next page')}
        disabled={page === totalPages}
        onClick={() => onPageChange(page + 1)}
        intent="next"
      />
    </nav>
  );
};

export default PaginationXs;
